var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLengthIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.229,
    height: 36.73,
    viewBox: "0 0 38.229 36.73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "length",
    transform: "translate(-4 -5.21)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11895",
    "data-name": "Path 11895",
    d: "M39.188,32.759a1.689,1.689,0,1,0,0-3.379H11.509a1.689,1.689,0,0,0,0,3.379Z",
    transform: "translate(-2.231 -9.267)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11896",
    "data-name": "Path 11896",
    d: "M40.539,44.34H5.689a1.689,1.689,0,1,0,0,3.379h34.85a1.689,1.689,0,0,0,0-3.379Z",
    transform: "translate(0 -15.003)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11897",
    "data-name": "Path 11897",
    d: "M57.593,9.051,49.17,7.51v4.982l8.423-1.541Z",
    transform: "translate(-17.319 -0.882)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11898",
    "data-name": "Path 11898",
    d: "M6.99,38.549a1.692,1.692,0,0,0,1.689,1.689H39.836a1.689,1.689,0,1,0,0-3.379H8.679A1.688,1.688,0,0,0,6.99,38.549Z",
    transform: "translate(-1.146 -12.135)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11899",
    "data-name": "Path 11899",
    d: "M40.2,13.022H44.07a.305.305,0,0,0,.308-.308v-7.2a.305.305,0,0,0-.308-.308H40.2a.305.305,0,0,0-.308.308v7.189A.307.307,0,0,0,40.2,13.022Z",
    transform: "translate(-13.761)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11900",
    "data-name": "Path 11900",
    d: "M12.252,20.254H23.7V18.564a1.692,1.692,0,0,0-1.689-1.689H12.252a2.343,2.343,0,0,1,0-4.686H25.866V8.81H12.252a5.722,5.722,0,1,0,0,11.444Z",
    transform: "translate(-0.97 -1.38)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11901",
    "data-name": "Path 11901",
    d: "M39.842,51.82H8.679a1.689,1.689,0,0,0,0,3.379H39.836a1.689,1.689,0,0,0,.006-3.379Z",
    transform: "translate(-1.146 -17.871)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11902",
    "data-name": "Path 11902",
    d: "M39.184,59.3H11.5a1.689,1.689,0,0,0,0,3.379H39.178a1.689,1.689,0,0,0,.006-3.379Z",
    transform: "translate(-2.228 -20.739)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLengthIcon);
export default __webpack_public_path__ + "static/media/length_icon.54372d48b05f33fa4de6ef1c5270de9e.svg";
export { ForwardRef as ReactComponent };